import DOMPurify from 'dompurify';
import { marked } from 'marked';

// Note: Would like to move this to web/common, but doing so runs into a
// problem due to commonjs/import/require issues loading marked.
// See https://github.com/markedjs/marked/issues/2265

export function htmlFromMarkdown(value: string) {
  return DOMPurify.sanitize(marked.parse(value, { breaks: true }));
}
